export const HOME_GALLERY_ITEMS = [
  { id: 'h1', title: 'Casal de noivos', description: 'Topo de bolo · Mini Boneco', image: '/media/funko/5.jpg' },
  { id: 'h2', title: 'Golden Retriever', description: 'Pelagem dourada · Mini Pet', image: '/media/pet/4.jpg' },
  { id: 'h3', title: 'Mini Boneco', description: 'Boneco personalizado', image: '/media/funko/1.jpg' },
  { id: 'h4', title: 'Com uniforme', description: 'Miniatura no estilo da profissão', image: '/media/funko/2.jpg' },
  { id: 'h5', title: 'Mini Pet', description: 'Detalhes de expressão', image: '/media/pet/1.jpg' },
  { id: 'h6', title: 'Formatura', description: 'Marcando a conquista · Mini Boneco', image: '/media/funko/3.jpg' },
  { id: 'h7', title: 'Mini Boneco', description: 'Acabamento artesanal', image: '/media/funko/4.jpg' },
  { id: 'h8', title: 'Projeto Pet', description: 'Pintura feita à mão', image: '/media/pet/2.jpg' },
  { id: 'h9', title: 'Bulldog Francês', description: 'Aquele sorriso característico', image: '/media/pet/3.jpg' },
];
